import React, { useContext } from "react";
import { LocalizationContext } from "../../../../locales/Translation";

type Props = {
  price: string;
  unit?: string;
};
const Price = ({ price, unit }: Props) => {
  const { translations } = useContext(LocalizationContext);

  return (
    <div className={"book-detail__section"}>
      <div className={"book-detail__section-title"}>
        {translations.settings.price}
      </div>
      <div className={"book-detail__price-wrapper"}>
        <div className={"book-detail__price"}>
          <div>{translations.StartingFrom}</div>
          <span className={"value"}>
            {price} / {unit ? unit : translations.day}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Price;
